module.exports = __webpack_public_path__ + "static/media/18ECA37.3b4b7670.jpg";